import React from "react";
import { Box, Typography } from "@mui/material";
import { useCurrencySetting } from "@/hooks/useSetting";

const PretPoints: React.FC<{ points: number | undefined }> = ({ points }) => {
  const currencySetting = useCurrencySetting();

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <Box
        position="relative"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <img
          src="/assets/icons/star-icon-green.svg"
          style={{ minHeight: 40, minWidth: 40 }}
        />
        <Typography
          variant="labelLarge"
          fontWeight="500"
          color="black"
          lineHeight={1}
          position="absolute"
          sx={{
            top: "55%",
            transform: "translateY(-50%)",
          }}
        >
          {points || "-"}
        </Typography>
      </Box>
      <Typography
        variant="labelSmall"
        fontWeight="bold"
        color="black"
        lineHeight={1}
        sx={{ marginTop: 1 }}
      >
        {currencySetting.mask || "£"}
      </Typography>
    </Box>
  );
};

export default PretPoints;
